// extracted by mini-css-extract-plugin
module.exports = {"c-profile-account-tab__form":"ProfileAccountTab_c-profile-account-tab__form__exG9Z"};